var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.808,
    cy: 12,
    r: 10.5,
    fill: "#353844"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.718 15.211l.466-2.963h-2.918v-1.923c0-.81.407-1.602 1.714-1.602h1.328V6.2S16.104 6 14.953 6c-2.404 0-3.974 1.42-3.974 3.989v2.259H8.308v2.963h2.67v7.165a10.853 10.853 0 003.289 0V15.21h2.45z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/icons/facebook-2-56438a93.svg";
export { SvgFacebook2 as ReactComponent };